/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompatibilityCheckResponse
 */
export interface CompatibilityCheckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CompatibilityCheckResponse
     */
    isCompatible: boolean;
}

export function CompatibilityCheckResponseFromJSON(json: any): CompatibilityCheckResponse {
    return CompatibilityCheckResponseFromJSONTyped(json, false);
}

export function CompatibilityCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompatibilityCheckResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isCompatible': json['isCompatible'],
    };
}

export function CompatibilityCheckResponseToJSON(value?: CompatibilityCheckResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isCompatible': value.isCompatible,
    };
}

